import { render, staticRenderFns } from "./LegalEntityDocuments.vue?vue&type=template&id=956a7412&scoped=true"
import script from "./LegalEntityDocuments.vue?vue&type=script&lang=js"
export * from "./LegalEntityDocuments.vue?vue&type=script&lang=js"
import style0 from "./LegalEntityDocuments.vue?vue&type=style&index=0&id=956a7412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956a7412",
  null
  
)

export default component.exports